const LS_KEY = 'shipper-portal-language'

export const LanguageStorage = {
  save: (lang: string) => {
    localStorage.setItem(LS_KEY, lang)
  },
  get: () => localStorage.getItem(LS_KEY),
}
